import AppNavigation from './AppNavigation';

export default AppNavigation;
